import { render, staticRenderFns } from "./labor.vue?vue&type=template&id=4c1a44d0&scoped=true"
import script from "./labor.vue?vue&type=script&lang=js"
export * from "./labor.vue?vue&type=script&lang=js"
import style0 from "./labor.vue?vue&type=style&index=0&id=4c1a44d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a44d0",
  null
  
)

export default component.exports